import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/auth/forgot-password', { email });
      
      if (response.data.success) {
        setSuccess(true);
      } else {
        setError(response.data.error || 'אירעה שגיאה');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'אירעה שגיאה בשליחת המייל');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-nexolog-navy to-nexolog-teal flex items-center justify-center px-4" dir="rtl">
        <div className="max-w-md w-full">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-white mb-2">Nexolog</h1>
            <p className="text-white/80 text-lg">מערכת ניהול עמלות נהגים</p>
          </div>

          <div className="bg-white rounded-2xl shadow-2xl p-8">
            <div className="text-center">
              <div className="mb-4">
                <svg className="w-16 h-16 text-green-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-nexolog-navy mb-4">
                המייל נשלח בהצלחה!
              </h2>
              <p className="text-gray-600 mb-6">
                קישור לאיפוס סיסמה נשלח לכתובת המייל שלך.
                <br />
                הקישור תקף לשעה אחת בלבד.
              </p>
              <button
                onClick={() => navigate('/login')}
                className="w-full bg-nexolog-teal hover:bg-nexolog-teal/90 text-white font-medium py-3 px-4 rounded-lg transition-colors"
              >
                חזור להתחברות
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-nexolog-navy to-nexolog-teal flex items-center justify-center px-4" dir="rtl">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">Nexolog</h1>
          <p className="text-white/80 text-lg">מערכת ניהול משכורות נהגים</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h2 className="text-2xl font-bold text-center text-nexolog-navy mb-2">
            שכחתי סיסמה
          </h2>
          <p className="text-center text-gray-600 mb-6 text-sm">
            הזן את כתובת המייל שלך ונשלח לך קישור לאיפוס הסיסמה
          </p>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm text-center">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                כתובת מייל
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-nexolog-teal focus:border-transparent transition-all"
                placeholder="your@email.com"
                required
                autoFocus
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-nexolog-teal hover:bg-nexolog-teal/90 text-white font-medium py-3 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'שולח...' : 'שלח קישור לאיפוס'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/login')}
              className="text-sm text-nexolog-teal hover:underline"
            >
              חזור להתחברות
            </button>
          </div>
        </div>

        <div className="text-center mt-6 text-white/60 text-sm">
          © 2025 Nexolog. כל הזכויות שמורות.
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

